import { Subscription } from 'rxjs';
import { Directive, OnInit, HostListener, Output, EventEmitter, OnDestroy, OnChanges, Input, ChangeDetectorRef } from '@angular/core';
import { BindingData, BindingList, ViewModel, Change } from '@farris/devkit';
import { ListViewComponent } from '@farris/ui-list-view';
@Directive({
  selector: '[farrisListviewBinding]'
})

export class FarrisListViewBindingDirective implements OnInit, OnDestroy, OnChanges {
  bindingDataChangeEvent: Subscription;

  /**
   * ä¸»é®
   */
  protected get primaryKey() {
    return this.bindingList.primaryKey;
  }

  @Input() supportPaged: boolean = true;
  /**
   * éä¸­è¡åæ¢äºä»¶
   */
  @Output() selectedRowChange: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private bindingData: BindingData,
    private viewModel: ViewModel,
    private listview: ListViewComponent) {

  }

  ngOnInit() {
    // ç»å®æ°æ®
    this.bindData();
    this.registerBindingDataChangeEvent();

  }

  ngOnChanges() {
    this.bindData();
  }

  ngOnDestroy() {
    this.unRegisterBindingDataChangeEvent();
  }

  /**
   * è·ååé¡µä¿¡æ¯
   */
  protected getPagingInfo() {
    const bindingPath = this.viewModel.bindingPath;
    const bindingData = this.viewModel.bindingData;
    let pagingInfo = bindingData.pagingInfo;
    if (bindingPath === '/') {
      return pagingInfo;
    } else {
      const bindingPaths = bindingPath.substr(1).split('/').filter(item => !!item && item.length > 0).map(item => {
        return item.substring(0, item.length - 1);
      });
      bindingPaths.forEach(path => {
        pagingInfo = pagingInfo && pagingInfo[path];
      });
      return pagingInfo;
    }
  }

  /**
   * è®¾ç½®listviewå±æ§
   */
  private setListViewPageProps() {
    const data = this.bindingList.toJSON();
    let skip = 0;
    const { pageIndex = 1, pageSize = 0 } = this.getPagingInfo() || {};
    let { total = 0 } = this.getPagingInfo() || {};
    if (pageIndex > 0) {
      skip = (pageIndex - 1) * pageSize;
    }
    if (pageSize === 0 && total === 0) {
      total = data.length;
    }
    this.listview.supportPaging = this.supportPaged;
    this.listview.pageIndex = pageIndex;
    this.listview.pageSize = pageSize;
    this.listview.total = total;
    let currentPage = pageIndex;
    const itemsPerPage = pageSize;
    let totalItems = total;
    if (pageSize === 0) {
      // this.listview.supportPaging = false;
      this.listview.pageIndex = pageIndex;
      this.listview.total = total;
      currentPage = 1;
      totalItems = total;
    }
    if (this.listview.paginationOptions) {
      this.listview.paginationOptions.itemsPerPage = itemsPerPage;
      this.listview.paginationOptions.currentPage = currentPage;
      this.listview.paginationOptions.pageList = this.listview.pageList;
      this.listview.paginationOptions.totalItems = totalItems;
    }
    const listViewChangeDetectRef: ChangeDetectorRef = this.listview['cdr'] as ChangeDetectorRef;
    if (listViewChangeDetectRef) {
      listViewChangeDetectRef.detectChanges();
    }
    const paginationDirective = this.listview.pager && this.listview.pager['paginationDirective'];
    if (paginationDirective && paginationDirective['service']) {
      try {
        paginationDirective['service'].instances[this.listview.pager.id] = { ...this.listview.paginationOptions };
        paginationDirective['service'].setTotalItems(this.listview.pager.id, totalItems);
        paginationDirective.changeDetectorRef.detectChanges();
      } catch { }
    }
  }

  /*
   * è·åç»å®æ°æ®
   */
  protected get bindingList(): BindingList {
    // æ ¹å®ä½
    if (this.viewModel.bindingPath === '/' || !this.viewModel.bindingPath) {
      return this.bindingData.list;
    }
    // å­å®ä½
    let bindingPath = this.viewModel.bindingPath.substr(1);
    bindingPath = bindingPath[0].toLowerCase() + bindingPath.substring(1, bindingPath.length);
    const paths = bindingPath.split('/');

    const filteredPaths = paths.filter((part: string) => {
      return part !== '';
    });
    return this.bindingData.getValue(filteredPaths);
  }

  /* ç»å®æ°æ® */
  private bindData() {
    this.setListViewPageProps();
    const data = this.bindingList.toArray();
    this.listview.setData(data);
  }

  /*
       * åå°éä¸­è¡åæ¢äºä»¶
       * @description ç»ä¸åéæ¨¡å¼åå¤éæ¨¡å¼ä¸çè¡åæ¢äºä»¶
       */
  protected fireSelectedRowChange(selectedRowContext: any) {
    this.selectedRowChange.emit(selectedRowContext);
  }

  /**
   * è®¾ç½®BindingListçå½åè¡
   * @param id å½åè¡åç 
   */
  protected setSelectionIdToBindingData(id: string): void {
    this.bindingList.setCurrentId(id, true);
  }

  /**
   * æ°æ®æºåçåæ´
   * @param change åæ´
   */
  protected onBindingDataChange(change: Change) {
    this.bindData();
    this.updateSelectedRow(change);
  }
  /**
   * è®¾ç½®å½åè¡
   * @param change åæ´
   */
  private updateSelectedRow(change?: Change) {
    if (!this.bindingList || !this.bindingList.currentId) {
      return;
    }
    if (this.viewModel && this.viewModel.frameContext.bindingData.rowSelectedEventSuspend === true) {
      return;
    }
    const { id = null } = this.listview.clickItem || {};
    const currentId = this.bindingList.currentId;
    // gridå½åè¡ä¸bingingListå½åè¡ä¸è´ï¼æ é¡»åæ¢
    if (id === currentId) {
      return;
    }
    this.selectRow(this.bindingList.currentId);
  }
  protected selectRow(id: any) {
    if (this.listview && typeof this.listview.selectRow === 'function') {
      this.listview.selectRow(id);
    }
  }
  /**
   * æ³¨åbindingdataååäºä»¶
   */
  private registerBindingDataChangeEvent() {
    this.bindingDataChangeEvent = this.bindingData.changes.subscribe((change: Change) => {
      this.onBindingDataChange(change);
    });
  }
  /**
   * åæ¶bindingdataååè®¢é
   */
  private unRegisterBindingDataChangeEvent() {
    this.bindingDataChangeEvent.unsubscribe();
  }
  private setChecks(ids: string[]) {
    this.viewModel.uiState.setPropertyValue('ids', ids);
  }
  /* åæ¢è¡äºä»¶ */
  @HostListener('listClick', ['$event'])
  changeRow(event: any) {
    const { index, data, checkChangeEvent } = event;
    if (checkChangeEvent === false || !event.hasOwnProperty('checkChangeEvent')) {
      if (data && Array.isArray(data) && data.length > 0) {
        const id = data[0] && data[0][this.primaryKey] || null;
        if (id) {
          this.setSelectionIdToBindingData(id);
        }
      }
      this.listview.activeIndex = index;
      this.fireSelectedRowChange(event);
    }
  }

  /**
   * åæ¢é¡µç è§¦åäºä»¶
   * @param event åæ¢é¡µç åæ°
   */
  @HostListener('pageChanged', ['$event'])
  public pageChangedHandler(event: any) {
    let pageIndex = event.pageInfo.pageIndex;
    const pageSize = event.pageInfo.pageSize;
    if (pageIndex < 1) {
      pageIndex = 1;
    }
    const skip = (pageIndex - 1) * pageSize;
    this.bindingData.setPagingInfo(skip, pageSize, this.bindingData.bindingPath);
  }

  /**
   * è®¾ç½®æ¯é¡µæ°æ®æ¡æ°è§¦åäºä»¶
   * @param event åæ¢é¡µç åæ°
   */
  @HostListener('pageSizeChanged', ['$event'])
  public pageSizeChangedHandler(event: any) {
    const { pageIndex, pageSize } = event.pageInfo;
    const skip = (pageIndex - 1) * (+pageSize);
    this.bindingData.setPagingInfo(skip, pageSize, this.bindingData.bindingPath);
  }
  @HostListener('checkValuesChange', ['$event'])
  public checkValuesChange(event: any) {
    const ids = event;
    this.setChecks(ids);
  }
}
